(function () {
    'use strict';

    angular
        .module('controlModule')
        .directive('selectControl', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                modalTitle: '@',
                whenSelectedControl: '&',
                hideClosed: '='
            },
            controller: ['$scope', '$modal', function ($scope, $modal) {

                $scope.selectControl = function () {

                    // Modal to select controil
                    var modalScope = $scope.$new(true);
                    modalScope.modalTitle = $scope.modalTitle;
                    modalScope.actualControls = $scope.controls;
                    modalScope.hideClosed = $scope.hideClosed;
                    var selectControlModal = $modal({
                        scope: modalScope,
                        template: '/app/shared/grc/control/selectControlModal.tpl.html',
                        placement: 'center'
                    });

                    modalScope.hideModal = function () {
                        selectControlModal.$promise.then(selectControlModal.hide);
                    }

                    modalScope.okModal = function () {
                        modalScope.hideModal();
                    }

                    // Add the selected control
                    modalScope.whenSelectControl = function (selectedControl) {
                        $scope.whenSelectedControl({ control: selectedControl });
                        modalScope.okModal();
                    }
                };
            }],
            link: function (scope, elem, attrs) {

                elem.bind('click', function () {
                    scope.selectControl();
                });
            }
        }
    }
})();